import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const CommunicationApi = createApi(config.COMM_API_URL);

export default CommunicationApi;
